"use client";

import { c as _c } from "react/compiler-runtime";
import useSWR from "swr";
import { categoryBrowseAction } from "@/actions/category";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { Label } from "@/ui/shadcn/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/shadcn/select";
import { YnsLink } from "@/ui/yns-link";
export const CategoryGridForm = t0 => {
  const $ = _c(7);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keepPreviousData: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: allCategories
  } = useSWR("getCategoriesAction", _temp, t1);
  let t2;
  if ($[1] !== data.categories) {
    t2 = data.categories ?? [];
    $[1] = data.categories;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const categoriesWithPadding = t2.concat(Array.from({
    length: 3 - (data.categories?.length ?? 0)
  }, _temp2));
  const context = useStoreBuilderContext();
  const t3 = "grid gap-3";
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-xs text-muted-foreground -mt-1">Categories group products together. You can define a category on the{" "}<YnsLink href="/admin/categories" className="underline">Categories</YnsLink>{" "}page.</p>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = categoriesWithPadding.map((categoryWithPadding, idx) => {
    const matchedCategory = allCategories?.data?.data?.find(c => "id" in categoryWithPadding ? c.id === categoryWithPadding.id : c.slug === categoryWithPadding.slug);
    return <Label key={idx + (matchedCategory?.id || "")} className="grid gap-1 mt-2"><span className="text-xs text-neutral-600 font-medium">Pick category number {idx + 1}</span><Select defaultValue={matchedCategory?.id ?? "__NULL__"} onValueChange={async value => {
        await context.saveSelectedPageSectionField({
          fieldPath: "categories",
          value: categoriesWithPadding
        });
        await context.saveSelectedPageSectionField({
          fieldPath: `categories.${idx}.id`,
          value
        });
      }} disabled={!allCategories?.data?.data?.length}><SelectTrigger className="w-full"><SelectValue placeholder="Select a category" /></SelectTrigger><SelectContent><SelectItem value="__NULL__">(none)</SelectItem>{allCategories?.data?.data?.map(_temp3)}</SelectContent></Select></Label>;
  });
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
function _temp() {
  return categoryBrowseAction({});
}
function _temp2() {
  return {
    slug: ""
  };
}
function _temp3(category) {
  return <SelectItem value={category.id} key={category.id}>{category.name}</SelectItem>;
}